import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["fileType", "extension", "size"],
  _excluded2 = ["file"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import { FileTypes } from '../constants';
import { getFileTypeFromFile } from '../utils/fileType';
import { splitNameAndExtension } from '../utils/file';
import { ICON_SIZES } from 'UIComponents/icon/IconConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const ICON_MARGIN_TOP = 3;
const IconContainerStyled = styled.div.withConfig({
  displayName: "FileTypeIcon__IconContainerStyled",
  componentId: "bssu8p-0"
})(["margin-top:", "px;"], ICON_MARGIN_TOP);
const WordExtensions = ['doc', 'docx'];
const ExcelExtensions = ['xls', 'xlsx', 'csv'];
const PowerPointExtensions = ['ppt', 'pptx'];
export default function FileTypeIcon(_ref) {
  let {
      fileType,
      extension,
      size = 35
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  let iconName = 'file';
  const numericalIconSize = typeof size === 'string' ? ICON_SIZES[size] : size;
  const adjustedIconSize = numericalIconSize - ICON_MARGIN_TOP;
  switch (fileType) {
    case FileTypes.AUDIO:
      iconName = 'audioFile';
      break;
    case FileTypes.MOVIE:
      iconName = 'videoFile';
      break;
    case FileTypes.DOCUMENT:
      if (extension === 'pdf') {
        iconName = 'pdfFile';
      } else if (WordExtensions.includes(extension)) {
        iconName = 'wordFile';
      } else if (ExcelExtensions.includes(extension)) {
        iconName = 'excelFile';
      } else if (PowerPointExtensions.includes(extension)) {
        iconName = 'powerPointFile';
      }
      break;
    case FileTypes.IMG:
      iconName = 'insertImage';
      break;
    default:
      break;
  }
  return /*#__PURE__*/_jsx(IconContainerStyled, {
    children: /*#__PURE__*/_jsx(UIIcon, Object.assign({}, props, {
      name: iconName,
      size: adjustedIconSize
    }))
  });
}
FileTypeIcon.propTypes = {
  fileType: PropTypes.oneOf(Object.values(FileTypes)).isRequired,
  extension: PropTypes.string.isRequired,
  size: PropTypes.number
};
export const LocalFileIcon = _ref2 => {
  let {
      file
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const {
    extension
  } = splitNameAndExtension(file.name);
  const fileType = getFileTypeFromFile(file);
  return /*#__PURE__*/_jsx(FileTypeIcon, Object.assign({}, props, {
    fileType: fileType,
    extension: extension
  }));
};
LocalFileIcon.propTypes = {
  file: PropTypes.instanceOf(File),
  size: PropTypes.number
};